<template>
  <div v-if="store.recording">
    <div class="flex items-center">
      <div class="text-xs text-gray-400 mx-2">recorded time:</div>
      <div>{{ totalDurationRecorded }}</div>
    </div>
  </div>
</template>
<script>
import { store } from "../store.js";
export default {
  name: "RecordPanel",
  data: () => ({
    store,
  }),
  computed: {
    totalDurationRecorded: function () {
      let seconds = Math.floor((store.totalFramesRecorded / 60) * 10) / 10;
      let millisecs = Math.floor((store.totalFramesRecorded / 60) * 100) % 100;
      let fsecs = Math.floor(seconds).toString().padStart(2, "0");
      let mins = Math.floor(seconds / 60)
        .toString()
        .padStart(2, "0");
      return `${mins}m ${fsecs}s ${millisecs.toString().padStart(2, "0")}ms`;
    },
  },
};
</script>